import ReducerCreator from '../registerReducer';
import { buildStoreItem } from '../storeItemBuilder';
import * as STATES from './states.constants';
import { State } from '../../models';
import { StoreItem, copy } from '../Store';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';

const r = new ReducerCreator<State>()
    .register<State[]>(STATES.STATES_LOAD, (state, payload) => {
        const newState = new StoreItem<State>();
        newState.isLoading = true;
        return newState;
    })
    .register<State[]>(STATES.STATES_LOAD_SUCCESS, (state, payload) => {
        return buildStoreItem(payload);
    })
    .register<string>(STATES.STATE_DELETE_SUCCESS, (state, payload) => {
        const newState = copy(state);
        const { dictionary } = newState;
        delete (dictionary[payload]);
        return newState;
    })
    .register<State>(STATES.STATE_DELETE, (state, payload) => {
        const newState = copy(state);
        newState.isLoading = true;
        return newState;
    })
    .register<State>(STATES.STATE_UPDATE, (state, payload) => {
        const newState = copy(state);
        newState.isLoading = true;
        return newState;
    })
    .register<State>(STATES.STATE_UPDATE_SUCCESS, (state, payload) => {
        const newState = copy(state);
        const { dictionary } = newState;
        dictionary[payload.guid] = payload;
        newState.isLoaded = true;
        newState.isLoading = false;
        return newState;
    })
    .register<string>(APPLICATION_DISCONNECTED, (state, payload) => {
        const newState = new StoreItem<State>();
        return newState;
    });

export function statesReducer(state: StoreItem<State> = new StoreItem<State>(), action: { type: string, payload: any }) {
    return r.reduce(state, action);
}